import { Form, Col, Button, Typography } from "antd";
import styled, { createGlobalStyle } from "styled-components";

export const USER_FORM_MODAL_CLASS = "users-form-modal";

export const UserFormModalGlobalStyles = createGlobalStyle`
  .${USER_FORM_MODAL_CLASS} .ant-modal-body,
  .${USER_FORM_MODAL_CLASS} .ant-form,
  .${USER_FORM_MODAL_CLASS} .ant-row,
  .${USER_FORM_MODAL_CLASS} .ant-col {
    max-width: 100%;
    min-width: 0;
  }

  .${USER_FORM_MODAL_CLASS} .ant-modal-body {
    box-sizing: border-box;
  }
`;

export const StyledComponentWrapper = styled.div`
  background-color: #ffffff;
  width: 100%;
  max-width: 980px;
  margin: 24px auto;
  padding: 1px 28px;
  @media (max-width: 1200px) {
    max-width: 720px;
  }
  @media (max-width: 788px), (max-width: 922px) {
    max-width: 580px;
  }
  @media (max-width: 720px) {
    max-width: 320px;
  }
`;

export const Title = styled(Typography.Title)`
  && {
    font-size: 36px;
    font-weight: 700;
  }
`;


export const StyledForm = styled(Form)`
  width: 424px;
  @media (max-width: 1200px) {
    max-width: 360px;
  }
  @media (max-width: 788px), (max-width: 922px) {
    max-width: 320px;
  }
  @media (max-width: 720px) {
    max-width: 280px;
  }
`;

export const StyledFilterButton = styled(Button)`
  height: 45px;
  width: 45px;
`;

export const StyledButton = styled(Button)`
  margin: 8px 6px;
  width: 96px;
`;

export const StyledButtonWrap = styled(Col)`
  text-align: right;
`;